import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { ConfirmationComponent } from 'src/app/shared/confirmation/confirmation.component';
import {
  StepMoreInformation,
  StepOCRDaeResponse,
} from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { DeleteDataService } from 'src/app/shared/services/delete-data.service';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

import { HttpErrorResponse } from '@angular/common/http';
import { UpdateDataTokenCode } from 'src/app/shared/class/update-data';
import {
  City,
  Country,
  DataSelects,
  DetailDocument,
  DocumentCategory,
  ExperienceType,
  Gender,
  MaritalStatus,
  Occupation,
  State,
} from 'src/app/shared/interfaces/data-selects';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-step-mas-informacion',
  templateUrl: './step-mas-informacion.component.html',
  styleUrls: ['./step-mas-informacion.component.scss'],
})
export class StepMasInformacionComponent
  extends AutoUnsubscribeComponent
  implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataMoreInformation!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepMoreInformationSavedEvent = new EventEmitter<boolean>();
  @ViewChild('singleSelect') singleSelect!: MatSelect;

  public formStepMoreInformation: FormGroup;
  protected _onDestroy = new Subject<void>();

  public selectedState: String = '';

  public experienceTypes: ExperienceType[] = [];
  public jobCity: City[] = [];
  public gender: Gender[] = [];
  public countries: Country[] = [];
  public stateArray: State[] = [];
  public countryCtrl: FormControl = new FormControl();
  public stateCtrl: FormControl = new FormControl();
  public statesFilterCtrl: FormControl = new FormControl();
  public filteredStates: ReplaySubject<State[]> = new ReplaySubject<State[]>(1);
  public maritalStatusList: MaritalStatus[] = [];
  public activities: Occupation[] = [];
  public colonies: State[] = [];
  public documents: DocumentCategory[] = [];
  public hideButton = true;
  public isOpen = false;
  public docId!: string;
  public numberRequest!: string;
  public referalQr!: string;
  public codeReferral!: string;
  public codePostal!: any;
  public creditTypeUpdate!: string;

  private allowedFileTypes = [
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/x-compressed',
  ];

  constructor(
    private frmBuilder: FormBuilder,
    private requestFormService: RequestFormService,
    private putDataService: PutDataService,
    private getDataService: GetDataService,
    private postDataService: PostDataService,
    private deleteDataService: DeleteDataService,
    public dialog: MatDialog,
    private router: Router,
    private activatedRouter: ActivatedRoute
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.referalQr = params['referall'];
      this.codeReferral = params['referralCode'];
    });

    const INE = /^[0-9a-zA-Z]{18}$/;
    const POSTALCODE = /^[0-9]{5}$/;
    const NSS = /^[0-9]{11}$/;
    const CURP = /^[0-9üñça-zÜÑÇA-Z]{10}[H|Mh|m]{1}[0-9üñça-zÜÑÇA-Z]{7}$/;
    const RFC = /^[0-9a-zA-Z]{13}$/;
    const NUMEXT = /^([a-zA-Z0-9]+\s*)*[a-zA-Z0-9]+$/;
    this.formStepMoreInformation = this.frmBuilder.group({
      experienceTypeCode: [''],
      jobCityId: ['', [Validators.required, Validators.maxLength(45)]],
      anotherJobCity: ['', [Validators.maxLength(45)]],
      totalDependents: ['', [Validators.required, Validators.maxLength(2)]],
      canRotateShift: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      countryOfBirthCode: ['', [Validators.required, Validators.maxLength(50)]],
      maritalStatus: ['', [Validators.required]],
      rfc: ['', [Validators.required, Validators.pattern(RFC)]],
      ine: ['', [Validators.required, Validators.pattern(INE)]],
      occupationId: ['', [Validators.required]],
      otherOccupation: ['', [Validators.maxLength(45)]],
      socialSecurityNumber: [
        '',
        [Validators.required, Validators.pattern(NSS)],
      ],
      postalCodeId: ['', [Validators.required, Validators.pattern(POSTALCODE)]],
      street: ['', [Validators.required, Validators.maxLength(50)]],
      externalNumber: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(NUMEXT),
        ],
      ],
      internalNumber: [
        '',
        [Validators.maxLength(10), Validators.pattern(NUMEXT)],
      ],
      colonyId: ['', [Validators.required, Validators.maxLength(60)]],
      stateId: ['', [Validators.required, Validators.maxLength(50)]],
      curp: ['', [Validators.required, Validators.pattern(CURP)]],
    });
    this.stateCtrl.setValidators([Validators.required]);
  }

  ngOnInit(): void {
    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepMoreInformation.dirty) {
          this.saveStepMoreInformation();
        } else {
          this.openRequestInformationDialog();
        }
      }
    });

    this.requestFormService
      .getDataDocumentsOCRObservable()
      .subscribe((resp) => {
        this.loadDataOCR(resp);
      });

    if (!this.requestFormService.getDataForm().requestNumber) {
      this.loadDataOCR(this.requestFormService.getDataDocumentsOCR());
    }

    this.requestFormService.getDataFormObservable().subscribe(() => {
      this.loadUpdateFormStepMoreInformation();
    });

    if (this.requestFormService.getDataForm().requestNumber) {
      this.loadUpdateFormStepMoreInformation();
      this.formStepMoreInformation.controls['curp'].disable();
    }

    this.statesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        if (this.statesFilterCtrl.value) {
          this.filterStates();
        }
      });
  }

  selectionCountry(country: string, { isUserInput }: MatOptionSelectionChange) {
    if (
      isUserInput ||
      this.requestFormService.getUpdateForm().aboutYou?.stateOfBirth
    ) {
      this.filteredStates.next(
        this.stateArray.filter((state) => state.countryCode == country)
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const searchForm = this.requestFormService.getUpdateForm();
    const docTypes = searchForm ? searchForm.documents : [];

    if (changes['dataMoreInformation']?.currentValue) {
      this.experienceTypes = this.dataMoreInformation.experienceTypes;
      this.jobCity = this.dataMoreInformation.cities;
      this.stateArray = this.dataMoreInformation.states;
      this.countries = this.dataMoreInformation.countries;
      this.gender = this.dataMoreInformation.genders;
      this.maritalStatusList = this.dataMoreInformation.maritalStatus.sort(
        (a, b) => a.name.localeCompare(b.name)
      );
      this.activities = this.dataMoreInformation.occupations
        .filter((ocu) => ocu.name != 'Otra')
        .sort((a, b) => a.name.localeCompare(b.name));
      const activityOther = this.dataMoreInformation.occupations.find(
        (act) => act.name == 'Otra'
      );
      if (activityOther) {
        this.activities.push(activityOther);
      }

      this.documents = this.dataMoreInformation.documentCategories.filter(
        (op) => op.code === 'SECONDARY'
      );
      this.documents.forEach((document) => {
        document.documents = document.documents.map((d) => {
          const doc = docTypes.find((docu) => docu.typeId == d.id);
          if (doc) {
            d.uploaded = true;
            d.fileName = doc.fileName;
          }
          return d;
        });
      });
      this.checkEvent();
      this.filteredStates.next(this.stateArray.slice());
    }
  }

  checkEvent() {
    const docUpload = this.documents.every((doc) =>
      doc.documents.every((d) => d.uploaded)
    );
    this.formValidEvent.emit(
      this.formStepMoreInformation.valid &&
      !this.stateCtrl.invalid &&
      !this.formStepMoreInformation.get('curp')?.invalid &&
      docUpload
    );
  }

  protected setInitialValueStates() {
    this.filteredStates
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: State, b: State) =>
          a && b && a.id === b.id;
      });
  }

  protected filterStates() {
    const countrySelected =
      this.formStepMoreInformation.value.countryOfBirthCode === 'MX'
        ? 'MX'
        : 'EX';
    if (!this.stateArray) {
      return;
    }

    const search = this.statesFilterCtrl.value?.toLowerCase();
    if (!search) {
      this.filteredStates.next(this.stateArray.slice());
      return;
    }

    this.filteredStates.next(
      this.stateArray
        .filter((state) => state.name.toLowerCase().indexOf(search) > -1)
        .filter((state) => state.countryCode == countrySelected)
    );
  }

  getStepMoreInformationObject(): StepMoreInformation {
    return {
      ...this.formStepMoreInformation.value,
      totalDependents: parseInt(
        this.formStepMoreInformation.get('totalDependents')?.value,
        10
      ),
      stateOfBirthId: this.stateCtrl.value,
      stateId: this.codePostal.state.id,
      postalCodeId: this.codePostal.id,
      curp: this.formStepMoreInformation.get('curp')?.value,
    };
  }

  loadDataOCR(value: StepOCRDaeResponse) {
    this.getPostalCode(value.postalCode);
    this.formStepMoreInformation.patchValue({
      rfc: value.rfc,
      ine: value.ine,
      socialSecurityNumber: value.nss,
      postalCodeId: value.postalCode,
      curp: value.curp,
      stateCtrl: this.stateArray.find((op) => {
        if (
          value.stateOfBirth
            ? op.name.toLowerCase() === value.stateOfBirth.toLowerCase()
            : ''
        ) {
          value.stateOfBirth ? this.stateCtrl.setValue(op.id) : '';
        }
      }),
    });
  }

  saveStepMoreInformation() {
    if (this.formStepMoreInformation.valid && this.stateCtrl.valid) {
      const putUpdateMoreInformation$ = this.putDataService
        .putUpdateMoreInformation(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStepMoreInformationObject()
        )
        .subscribe({
          next: () => {
            this.openRequestInformationDialog();
            this.hideButton = false;
          },
          error: (err) => {
            this.openRequestInformationErrorDialog(err);
          },
        });
      this.subscriptions.push(putUpdateMoreInformation$);
    } else {
      FormsValidators.markFormGroupTouched(this.formStepMoreInformation);
    }
  }

  validInputAnotherJobCity({ isUserInput, source }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }

    const otrControlValidators =
      source.value == 'OTR' ? [Validators.required] : [];

    this.formStepMoreInformation.controls['anotherJobCity'].setValidators(
      otrControlValidators
    );

    this.formStepMoreInformation.controls[
      'anotherJobCity'
    ].updateValueAndValidity();
  }

  validInputOtherOccupation({ isUserInput, source }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }

    const otherOcuppationValidators =
      source.value == 32 ? [Validators.required] : [];

    this.formStepMoreInformation.controls['otherOccupation'].setValidators(
      otherOcuppationValidators
    );

    this.formStepMoreInformation.controls[
      'otherOccupation'
    ].updateValueAndValidity();
  }

  getPreviousPostalCode(event: any) {
    this.getPostalCode(event.target.value);
  }

  getPostalCode(event: string) {
    const getPostalCode$ = this.getDataService
      .getPostalCode(this.getCountry().toUpperCase(), event)
      .subscribe((resp) => {
        this.colonies = resp.colonies;
        this.formStepMoreInformation.get('stateId')?.setValue(resp.state.name);
        this.codePostal = {
          state: resp.state,
          municipality: resp.municipality,
          id: resp.id,
        };
      });
    this.subscriptions.push(getPostalCode$);
  }

  saveDocument(event: any, document: DetailDocument) {
    const fileType = event.target.files[0].type;
    const fileMimeType = event.target.files[0].size < 5000000;
    if (this.allowedFileTypes.includes(fileType) && fileMimeType) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      document.spinner = true;
      const postSaveDocument$ = this.postDataService
        .postSaveDocument(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          document.id,
          formData
        )
        .subscribe((resp) => {
          document.spinner = false;
          document.uploaded = true;
          document.fileName = resp.fileName;
          this.checkEvent();
        });
      this.subscriptions.push(postSaveDocument$);
    } else {
      this.errorFormatDialog();
    }
  }

  viewDocuments(doc: DetailDocument) {
    const getViewDocuments$ = this.getDataService
      .getViewDocuments(
        this.getCountry().toUpperCase(),
        this.getApplicationId(),
        doc.fileName
      )
      .subscribe((resp) => {
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL);
      });
    this.subscriptions.push(getViewDocuments$);
  }

  confirmDeleteDocuments(doc: DetailDocument) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Eliminar',
      question: `¿Desea eliminar el documento : ${doc.name}?`,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          const deleteDocuments$ = this.deleteDataService
            .deleteDocuments(
              this.getCountry().toUpperCase(),
              this.getApplicationId(),
              doc.fileName
            )
            .subscribe({
              next: () => {
                this.successErrorDeleteDocumentDialog();
                doc.uploaded = false;
              },
              error: (err) => {
                this.successErrorDeleteDocumentDialog(err.status);
              },
            });
          this.subscriptions.push(deleteDocuments$);
        }
      });
  }

  errorFormatDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Error de Formato.',
      question: `Solo puede agregar documentos con los siguientes formatos: .PDF, .JPG, .PNG y con un tamaño menor a 5MB. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  successErrorDeleteDocumentDialog(error?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: error ? 'Error!' : 'Éxito!',
      question: error
        ? `Ha ocurrido un error, no se pudo eliminar el documento.`
        : `El documento se eliminó correctamente. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  openRequestInformationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Su solicitud se guardó con exito',
      question: `Gracias por completar el formulario, nos pondremos en contacto con usted a la brevedad.`,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }

  openRequestInformationErrorDialog(event: HttpErrorResponse) {
    let errorMessage = 'Ha ocurrido un error.';

    const pendingToLoadDocumentsError =
      /(?<=^Document Not Found: )\d+|(?<=Tipo Documento: )\d+$/.test(
        event.error.message
      );

    const errorCurpInUse = `CURP_IN_USE`.match(event?.error.errors[0].code);

    const errorMissingDocuments = `MISSING_DOCUMENTS`.match(
      event?.error.errors[0].code
    );

    if (event.status === 400 && pendingToLoadDocumentsError) {
      errorMessage = `Debe completar los campos requeridos y/o cargar todos los documentos secundarios.`;
    }
    if (event.status === 400 && errorMissingDocuments) {
      errorMessage = `Debe cargar todos los documentos secundarios.`;
    }

    if (event.status === 409 && errorCurpInUse) {
      errorMessage = `Ya ha sido realizada una solicitud con el CURP que nos proporcionaste.
      \nSi desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  loadUpdateFormStepMoreInformation() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.stateCtrl.setValue(
      this.requestFormService.getUpdateForm().moreInformation.stateOfBirth.id
    );
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.getPostalCode(value.moreInformation.postalCode.number);
    this.formStepMoreInformation.patchValue({
      experienceTypeCode: value.moreInformation.experienceTypeCode.code,
      anotherJobCity: value.moreInformation.anotherJobCity,
      totalDependents: value.moreInformation.totalDependents,
      canRotateShift: value.moreInformation.canRotateWorkShift,
      gender: value.moreInformation.gender,
      countryOfBirthCode: value.moreInformation.countryOfBirth.code,
      maritalStatus: value.moreInformation.maritalStatus,
      rfc: value.moreInformation.rfc,
      ine: value.moreInformation.ine,
      occupationId: value.moreInformation.occupation.id,
      otherOccupation: value.moreInformation.otherOccupation,
      socialSecurityNumber: value.moreInformation.socialSecurityNumber,
      postalCodeId: value.moreInformation.postalCode.number,
      street: value.moreInformation.street,
      externalNumber: value.moreInformation.externalNumber,
      internalNumber: value.moreInformation.internalNumber,
      colonyId: value.moreInformation.colony.id,
      stateId: value.moreInformation.state.id,
      curp: value.moreInformation.curp,
      jobCityId: value.moreInformation.workCity.id,
    });
  }

  isLetterAndNumber(evt: KeyboardEvent) {
    const pattern = /^[0-9a-zA-Z]+$/;
    return pattern.test(evt.key);
  }

  deleteSpaceInit(evt: KeyboardEvent) {
    evt.target?.addEventListener('keyup', (e: any) => {
      const string = e.target!.value;
      e.target.value = string.trimStart();
    });
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }
}
